export var getDimensionsWithDefault = function getDimensionsWithDefault() {
  var dimensions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    width: '100%',
    height: '100%'
  };
  return {
    height: typeof dimensions.height === 'number' ? "".concat(dimensions.height, "px") : dimensions.height,
    width: typeof dimensions.width === 'number' ? "".concat(dimensions.width, "px") : dimensions.width
  };
};